import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import siteApi from '../../../../api/site';
import { isAdmin, isStaff } from '../../../../common/typeAssertionFunctions';
import useAuthStore from '../../../../datastore/useAuth';
import useSites from '../../../../datastore/useSites';
import useAlert from '../../../../hooks/useAlert';
import useLoadingModal from '../../../../hooks/useLoadingModal';


export default function OnlineOrdering() {
    const { currentUser } = useAuthStore()
    const { sites = [], loading: sitesLoading, fetchSites } = useSites()
    const { showAlert } = useAlert();
    const { loading, setLoading } = useLoadingModal()

    const onlineOrderingPaused = sites.some((s) => !s.isAcceptingOnlineOrders);

    async function toggleOnlineOrdering(currentState: boolean) {
        if (isStaff(currentUser) && isAdmin(currentUser)) {
            try {
                setLoading(true)
                const result = await siteApi.adminToggleOnlineOrdering(!currentState);
                if (result.status === 200) {
                    showAlert('Online Ordering updated', 'success');
                    await fetchSites()
                } else {
                    showAlert('Update online ordering failed', 'error');
                }
            } catch (err) {
                console.error(err)
                showAlert('Update online ordering failed', 'error');
            } finally {
                setLoading(false)
            }
        }
    }


    if (!currentUser || !isStaff(currentUser) || !isAdmin(currentUser)) return null

    return (
        <>
            <Divider />
            <Stack direction="row" spacing={4} sx={{ alignItems: 'center', paddingY: 2 }}>
                <Typography variant="h4">
                    {onlineOrderingPaused ? 'Online Ordering: Paused' : 'Online Ordering: Active'}
                </Typography>
                <Button
                    variant="contained"
                    color={onlineOrderingPaused ? 'success' : 'error'}
                    onClick={() => toggleOnlineOrdering(onlineOrderingPaused)}
                    disabled={loading || sitesLoading}
                >
                    {onlineOrderingPaused ? 'Resume' : 'Pause'}
                </Button>
            </Stack>
        </>

    )
}